import { Visibility, VisibilityOff } from '@material-ui/icons';
import React, { Component, Fragment } from 'react';

import {
  Grid,
  FormControl,
  InputLabel,
  InputAdornment,
  IconButton,
  Input,
  Select,
  Button,
  MenuItem,
} from '@material-ui/core';
import Modal from 'Components/Modal';
import { setImageForUpload } from 'Utils';

import Snackbar from 'Snackbar';
import Container from './components/Container';
import Footer from '../components/Footer';
import UploadImage from 'Components/UploadImage';
import Header from '../../Header';

//Milan Andrejic
import axios from 'Axios';
import ReqMsgWraper from '../../RequiredFieldsMessageWrapper';
import { withStyles } from '@material-ui/core/styles';
import InnerContainer from '../components/InnerContainer';
// TODO: Choose either FieldError or ErrorText and make it global
import FieldError from './components/FieldError';
import ErrorText from '../components/ErrorText';
import Required from '../components/Required';
import addresses from 'Addresses';

const styles = {
  root: {
    height: '270px',
  },
  input: {
    padding: '10px 14px',
  },
};

// TODO: Input fields are too similar, refactor to make them more reusable

class Step1 extends Component {
  state = {
    isPasswordVisible: false,
    isPasswordVisible2: false,
    confPassowrd: '',
    SnackbarMsg: '',
    selectedAddress: '',
    usernameError: false,
    confPassError: false,
  };

  handleOpenSnackbar = () => {
    this.setState({ openSnackbar: true });
  };

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  changePasswordVisibility = () => {
    this.setState(prevState => {
      return {
        isPasswordVisible: !prevState.isPasswordVisible,
      };
    });
  };

  changePasswordVisibility2 = () => {
    this.setState(prevState => {
      return {
        isPasswordVisible2: !prevState.isPasswordVisible2,
      };
    });
  };

  handleChangeAddress = event => {
    this.setState({ selectedAddress: event.target.value });
  };
  handleChangeConfPassowrd = password => event => {
    this.setState({
      confPassowrd: event.target.value,
      confPassError: event.target.value === password ? false : true,
    });
  };

  handleError = error => {
    console.error(error);
    this.setState(
      {
        SnackbarMsg: error.response
          ? error.response.data.message
          : 'Failed to connect to the database',
      },
      this.handleOpenSnackbar
    );
  };

  askForNextStep = ({ profile, acctok, next, changeFormSchema }) => () => {
    let formData = new FormData();
    formData.append('profileImage', profile.file);
    formData.append('token', acctok);

    let address = profile.address;

    if (this.props.registrationData.type === 'ARUP_REGISTRATION') {
      address = addresses.find(address => address.id === profile.address)[
        'address'
      ];
    }

    const data = {
      firstName: profile.firstName,
      lastName: profile.lastName,
      username: profile.usernameArup,
      password: profile.arupPassword,
      phone: profile.phone,
      mobileNumber: profile.mobile,
      regions: profile.regions,
      address,
    };

    if (this.props.registrationData.type === 'ARUP_REGISTRATION') {
      data.regionName = profile.regionName;
      delete data.regions;
    }

    if (this.props.registrationData.type === 'NON_ARUP_REGISTRATION') {
      // this is hardcoded here because initialy step 1 was with region and local address input fileds, where address was required for step 1 registration form. In step 2 this region will be overwritten
      data.regionName = 'UKIMEA';
      delete data.regions;
    }

    if (profile.image !== '') {
      axios
        .post('registration/create_picture', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          if (response) {
            formData = new FormData();
            axios
              .post('registration/' + acctok, data)
              .then(response => {
                if (response.data) {
                  changeFormSchema();
                  next();
                }
              })
              .catch(error => this.handleError(error));
          }
        })
        .catch(error => this.handleError(error));
    } else {
      axios
        .post('registration/' + acctok, data)
        .then(response => {
          if (response.data) {
            changeFormSchema();
            next();
          }
        })
        .catch(error => this.handleError(error));
    }
  };

  componentDidMount = () => {
    if (
      this.props.registrationData.step === 'STEP_2' ||
      this.props.registrationData.step === 'STEP_3' ||
      this.props.registrationData.step === 'STEP_4' ||
      this.props.registrationData.step === 'FINISHED'
    ) {
      this.props.next();
      this.props.changeFormSchema();
    }
  };

  checkIfUsername = (username, acctok) => {
    if (!username) {
      this.setState({
        usernameError: false,
      });
      return;
    }
    const usernameData = {
      username: username,
      accessToken: acctok,
    };
    axios
      .post('registration/check_username', usernameData)
      .then(response => {
        this.setState({
          usernameError: response.data,
        });
      })
      .catch(error => this.handleError(error));
  };

  setImage = setImageForUpload;

  render() {
    const {
      handleChange,
      next,
      step,
      setFieldValue,
      values: { profile },
      acctok,
      registrationData,
      isValid,
      changeFormSchema,
      errors,
    } = this.props;
    const { classes } = this.props;

    const nonArupRegistration =
      this.props.registrationData.type === 'NON_ARUP_REGISTRATION';

    return (
      <Fragment>
        <Modal.Header>
          <Header activeStep={step.id} registrationData={registrationData} />
        </Modal.Header>
        <Modal.Body withInnerScroll className="">
          <Container>
            <InnerContainer>
              <Grid container spacing={16} justify="center">
                <UploadImage
                  image={profile.image}
                  name="profile.image"
                  onImageChange={this.setImage(setFieldValue, 'profile.image')}
                  text="Add profile photo"
                />
              </Grid>
              <Grid container spacing={16}>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="first_name">
                      First name {!profile.firstName && <Required />}
                    </InputLabel>
                    <Input
                      id="first_name"
                      fullWidth
                      name="profile.firstName"
                      value={profile.firstName}
                      onChange={handleChange}
                      // aria-describedby="first_name_error"
                      // error={!!(errors.profile && errors.profile.firstName)}
                    />
                    {/* {errors.profile && errors.profile.firstName && (
                      <ErrorText
                        id="first_name_error"
                        text={errors.profile.firstName}
                      />
                    )} */}
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="last_name">
                      Last name {!profile.lastName && <Required />}
                    </InputLabel>
                    <Input
                      id="last_name"
                      fullWidth
                      name="profile.lastName"
                      value={profile.lastName}
                      onChange={handleChange}
                      // aria-describedby="last_name_error"
                      // error={!!(errors.profile && errors.profile.lastName)}
                    />
                    {/* {errors.profile && errors.profile.lastName && (
                      <ErrorText
                        id="last_name_error"
                        text={errors.profile.lastName}
                      />
                    )} */}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={16}>
                <Grid item xs={12}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="usernameArup">
                      Username {!profile.usernameArup && <Required />}
                    </InputLabel>
                    <Input
                      id="usernameArup"
                      fullWidth
                      name="profile.usernameArup"
                      value={profile.usernameArup}
                      onChange={e => {
                        handleChange(e);
                        this.checkIfUsername(e.target.value, acctok);
                      }}
                    />
                  </FormControl>
                  {this.state.usernameError && (
                    <FieldError>
                      The username already exists. Please use a different
                      username
                    </FieldError>
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={16} alignItems="flex-start">
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    {/* TODO: Name 'arupPassword is wrong because this modal is used by supplier users too, same goes for usernameArup above */}
                    <InputLabel htmlFor="arupPassword">
                      Password {!profile.arupPassword && <Required />}
                    </InputLabel>
                    <Input
                      id="arupPassword"
                      fullWidth
                      name="profile.arupPassword"
                      type={this.state.isPasswordVisible ? 'text' : 'password'}
                      value={profile.arupPassword}
                      onChange={handleChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={this.changePasswordVisibility}
                          >
                            {this.state.isPasswordVisible ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="changePassword">
                      Confirm password{' '}
                      {this.state.confPassowrd === '' ? <Required /> : null}
                    </InputLabel>
                    <Input
                      id="changePassword"
                      fullWidth
                      name="changePassword"
                      type={this.state.isPasswordVisible2 ? 'text' : 'password'}
                      value={this.state.confPassowrd}
                      onChange={this.handleChangeConfPassowrd(
                        profile.arupPassword
                      )}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={this.changePasswordVisibility2}
                          >
                            {this.state.isPasswordVisible2 ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  {this.state.confPassError && (
                    <FieldError>Password do not match</FieldError>
                  )}
                </Grid>
              </Grid>
              {!nonArupRegistration && (
                <Grid container spacing={16}>
                  <Grid item xs={6}>
                    <FormControl fullWidth margin="normal" id="test1">
                      <InputLabel htmlFor="regions" name="regions">
                        {registrationData.type !== 'COMPANY_REGISTRATION' &&
                        registrationData.type !==
                          'COMPANY_USER_REGISTRATION' ? (
                          <Fragment>
                            Region {!profile.regionName && <Required />}
                          </Fragment>
                        ) : (
                          <Fragment>
                            Regions{' '}
                            {profile.regions.length === 0 && <Required />}
                          </Fragment>
                        )}
                      </InputLabel>
                      {registrationData.type !== 'COMPANY_REGISTRATION' &&
                      registrationData.type !== 'COMPANY_USER_REGISTRATION' ? (
                        <Select
                          id="regionName"
                          fullWidth
                          name="profile.regionName"
                          value={profile.regionName}
                          onChange={handleChange}
                        >
                          {profile.regionsArup.map(r => {
                            return (
                              <MenuItem key={r.id} value={r.id}>
                                {r.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      ) : (
                        <Select
                          multiple
                          id="regions"
                          fullWidth
                          name="profile.regions"
                          value={profile.regions}
                          onChange={handleChange}
                          MenuProps={{
                            // TODO: find why the layout is broken when opening for the first time

                            // anchorEl: document.getElementById('test1'),
                            // anchorOrigin: {
                            //   vertical: 'bottom',
                            // horizontal: 'left',
                            // },
                            // transformOrigin: {
                            //   vertical: 'top',
                            //   horizontal: 'left',
                            // },
                            getContentAnchorEl: null,
                            className: classes.root,
                          }}
                        >
                          {profile.regionsCompany.map(r => {
                            return (
                              <MenuItem key={r.id} value={r.id}>
                                {r.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl fullWidth margin="normal">
                      <InputLabel htmlFor="address">
                        Local Address{' '}
                        {!profile.address && nonArupRegistration && (
                          <Required />
                        )}
                      </InputLabel>
                      {registrationData.type === 'ARUP_REGISTRATION' ? (
                        <Select
                          value={profile.address}
                          onChange={handleChange}
                          inputProps={{
                            name: 'profile.address',
                            id: 'address',
                          }}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {addresses
                            .filter(
                              address => address.region === profile.regionName
                            )
                            .map(address => (
                              <MenuItem value={address.id} key={address.id}>
                                {address.address}
                              </MenuItem>
                            ))}
                        </Select>
                      ) : (
                        <Input
                          id="address"
                          fullWidth
                          name="profile.address"
                          value={profile.address}
                          onChange={handleChange}
                        />
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
              )}

              <Grid container spacing={16} alignItems="flex-start">
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="phone">
                      Phone {!profile.phone && <Required />}
                    </InputLabel>
                    <Input
                      id="phone"
                      type="tel"
                      fullWidth
                      name="profile.phone"
                      value={profile.phone}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="mobile">Mobile</InputLabel>
                    <Input
                      id="mobile"
                      type="tel"
                      fullWidth
                      name="profile.mobile"
                      value={profile.mobile}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </InnerContainer>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Footer>
            {!isValid ||
            this.state.confPassError ||
            (this.state.confPassowrd === '' ? true : false) ? (
              <ReqMsgWraper>
                Required fields are indicated with
                <Required />
              </ReqMsgWraper>
            ) : null}
            <Button
              disabled={
                !isValid ||
                this.state.usernameError ||
                this.state.confPassError ||
                this.state.confPassowrd === ''
                  ? true
                  : false
              }
              onClick={this.askForNextStep({
                profile,
                acctok,
                next,
                changeFormSchema,
              })}
              variant="contained"
              color="primary"
            >
              {registrationData.type === 'USER_REGISTRATION'
                ? 'Finish'
                : 'Next'}
            </Button>
          </Footer>
        </Modal.Footer>
        <Snackbar
          open={this.state.openSnackbar}
          onClose={this.handleCloseSnackbar}
          msg={this.state.SnackbarMsg}
        />
      </Fragment>
    );
  }
}

export default withStyles(styles)(Step1);
